module.exports = __webpack_public_path__ + "static/media/26UNRWA25.c36f860b.jpg";